import {Component} from "../component";

export class App extends Component {
}
window.customElements.define('app-app', App);